import InputSelect from "../../components/UI/Inputs/InputSelect";
import { dataStateType } from "./utils";
import style from "./index.module.css";
import { FormState } from "react-hook-form";
import InputField from "../../components/UI/Inputs/InputField";
import { useTranslation } from "../../hooks/useTranslation";
import { useMemo } from "react";
import { AttributesOption, VehicleTypesT } from "../../utils/GeneralTypes";

type GroupedAttributesT = {
  selectShape: AttributesOption[];
  checkboxShape: AttributesOption[];
  textShape: AttributesOption[];
  allLength: number;
};

export default function VehicleAttributes({
  componentData,
  register,
  setValue,
  watchedInputs,
  formState,
  vehicleType: choosedVehicle,
}: ComponentPropsType) {
  const { locale } = useTranslation();
  const groupedAttributes = useMemo<GroupedAttributesT>(() => {
    const res: GroupedAttributesT = {
      selectShape: [],
      checkboxShape: [],
      textShape: [],
      allLength: 0,
    };
    componentData.attributes.forEach((attribute) => {
      // filtering attribute based on the selected category_0 is left for this component
      if (watchedInputs.category_0.toString() !== attribute.parentTruck?.toString()) {
        return;
      }
      switch (attribute.shape) {
        case "select":
          res.selectShape.push(attribute);
          break;
        case "checkbox":
          res.checkboxShape.push(attribute);
          break;
        case "text":
          res.textShape.push(attribute);
          break;
      }
    });
    res.allLength = res.selectShape.length + res.textShape.length + res.checkboxShape.length;
    return res;
  }, [componentData.attributes, watchedInputs.category_0]);

  return (
    <>
      <div className={style.page_section}>
        {groupedAttributes.allLength === 0 ? (
          <p style={{ textAlign: "center", color: "#959595" }}>{locale("no_attributes")}</p>
        ) : null}
        <div className={`row ${style.page_row}`}>
          {groupedAttributes.selectShape.map((attr) => {
            return (
              <div key={attr.id} className="col-sm-6">
                <InputSelect
                  props={{
                    ...register(`attributes.${attr.id}`, {
                      validate: (val: any) => {
                        if (attr?.required) {
                          return val !== "no_option" || locale("required_field");
                        }
                        return true;
                      },
                    }),
                    value: watchedInputs.attributes[attr.id],
                  }}
                  isRequired={attr?.required}
                  selectOptions={attr.values.map((val) => ({
                    label: val.name,
                    value: val.value,
                  }))}
                  label={attr.name}
                  watchedInputs={watchedInputs}
                  error={
                    formState?.errors?.attributes &&
                    (formState.errors.attributes as Record<string, any>)[attr?.id]?.message
                      ? (formState.errors.attributes as Record<string, any>)[attr.id].message
                      : ""
                  }
                />
              </div>
            );
          })}
          {groupedAttributes.textShape.map((attr) => (
            <div key={attr.id} className="col-sm-6">
              <InputField
                label={attr.name}
                type="text"
                isRequired={attr?.required}
                extraProps={register(`attributes.${attr.id}`, {
                  validate: (val: any) => {
                    if (attr?.required) {
                      return val !== "" || locale("required_field");
                    }
                    return true;
                  },
                })}
                error={
                  formState?.errors?.attributes &&
                  (formState.errors.attributes as Record<string, any>)[attr?.id]?.message
                    ? (formState.errors.attributes as Record<string, any>)[attr.id].message
                    : ""
                }
              />
            </div>
          ))}
        </div>
      </div>
      <div className={style.page_section}>
        <div className="row">
          {groupedAttributes.checkboxShape.map((attr) => (
            <div key={attr.id} className="col-sm-6">
              <InputField label={attr.name} type="checkbox" extraProps={register(`attributes.${attr.id}`)} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export type ComponentPropsType = {
  componentData: dataStateType;
  watchedInputs: any;
  vehicleType: VehicleTypesT;
  register: CallableFunction;
  setValue: CallableFunction;
  formState: FormState<any>;
};
